import React from 'react';
import ReactDOM from 'react-dom';
import { QueryParamProvider } from 'use-query-params';
import { globalHistory } from '@reach/router';
import App from './app';
import AppProviders from './context';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <QueryParamProvider reachHistory={globalHistory}>
    <AppProviders>
      <App />
    </AppProviders>
  </QueryParamProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
